/*
 * Usage:
 *
 * const StyledDiv = styled.div`
 *   ${ ellipsis };
 * `;
 */
export const ellipsis = `
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
